exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-main-js": () => import("./../../../src/pages/main.js" /* webpackChunkName: "component---src-pages-main-js" */),
  "component---src-templates-wp-page-tsx": () => import("./../../../src/templates/WpPage.tsx" /* webpackChunkName: "component---src-templates-wp-page-tsx" */)
}

